import React from "react";
export const SELLING_PATH = "/salja-med-klassen";
export const SELLING_TITLE =
  "Sälja med klassen – vad kan klassen sälja? | SalesPartner";
export const SELLING_H1 =
  "Sälja med klassen – vad kan klassen sälja och vad tjänar ni?";
export const SELLING_DESCRIPTION =
  "Vad kan man sälja med klassen? Jämför olika sätt att sälja, se exempel ur sortimentet med pris och vad klassen tjänar, och tips för en lyckad försäljning.";
export const SELLING_ANSWER =
  "Klassen kan sälja produkter som kunderna ändå använder – till exempel för kök och hem, textilier, hår- och hudvård eller teknikprylar – eller ordna loppis, kafé och liknande. Välj något med tydlig förtjänst per såld produkt och en enkel leverans.";
export const SELLING_SECTIONS = [
  ["val", "Vad kan man sälja med klassen?"],
  ["produkter", "Produkter ur sortimentet"],
  ["checklista", "Så väljer ni"],
  ["fortjanst", "Vad kan klassen tjäna?"],
  ["tips", "Tips för försäljningen"],
  ["salespartner", "SalesPartner för klassen"],
  ["fragor", "Vanliga frågor"],
];
export const SELLING_INTRO = [
  "Börja med att prata om vad klassen vill samla till och vilka som kan hjälpa till. Att sälja för klassen kan betyda att ni delar en digital produktförsäljning, men också att ni ordnar en egen aktivitet. Det viktiga är att förstå arbetet, kostnaderna och hur pengarna kommer in innan ni bestämmer er. Ett gemensamt mål gör det lättare att förklara varför ni säljer.",
  "I en produktförsäljning väljer kunden saker ur ett sortiment. Jämför pris, förtjänst och leverans, och fundera på om produkterna passar dem som vill stötta. Med SalesPartner beställer och betalar kunden online via personliga säljlänkar. Klassen får provision utifrån de produkter och varianter som säljs. Eleverna behöver inte ta emot kontantbetalningar själva.",
  "Ett annat spår är att ordna loppis, kafé eller disco. Då behöver ni planera sådant som plats, bemanning, inköp och vad som händer med det som blir över. Stäm av med skolan när aktiviteten berör skolans lokaler eller verksamhet. Välj utifrån er tid och de vuxna som kan hjälpa till, utan att utgå från att samma upplägg passar alla klasser.",
  React.createElement("a",{href:"/tjana-pengar-till-studenten",key:"student-guide"},"Tjäna pengar till studenten – läs guiden"),
];
export const CATEGORY_COPY = {
  "kitchen-serving":
    "Köks- och serveringsprodukter kan vara ett alternativ för kunder som vill handla något till hemmet. Låt köparen läsa produktbeskrivningen och bedöma om produkten passar det egna köket.",
  "home-textile":
    "Textilier och produkter för hemmet är sådant som kan användas i vardagen. Beskriv det som faktiskt ingår och hänvisa till produktinformationen om material, storlek och skötsel.",
  "bags-travel":
    "Väskor och produkter för resa kan passa den som söker något till utflykter eller vardagens packning. Olika kunder har olika behov, så låt produktens egenskaper vara utgångspunkten.",
  "tech-gadgets":
    "Teknik och praktiska prylar ger fler sorters produkter att välja mellan. Uppmuntra kunden att kontrollera funktioner och eventuell kompatibilitet på produktsidan innan den beställer.",
  haircare:
    "Hårvårdsprodukter är ett alternativ för kunder som vill välja något till sin vanliga rutin. Hänvisa till produktens egen beskrivning och undvik att lova ett visst resultat för alla.",
  "makeup-skincare":
    "Smink och hudvård kan passa köpare som redan är intresserade av den typen av produkter. Kunden väljer själv utifrån produktinformation, användning och sina egna önskemål.",
};
export const SELLING_CHECKLIST = [
  [
    "Tydlig förtjänst i kronor",
    "Jämför hur mycket klassen får per såld produkt. Provisionen kan skilja mellan produkter och varianter, så en enda procentsats eller ett planeringsvärde beskriver inte hela sortimentet. Se vad som gäller för det kunden faktiskt köper.",
  ],
  [
    "Ett pris som passar köparna",
    "Fundera på vilka som vill handla och vilka priser som känns rimliga för dem. Visa priset tydligt och låt kunden välja. Ett högre produktpris behöver inte vara rätt val för varje köpare eller varje klass.",
  ],
  [
    "Produkter som används i vardagen",
    "Titta på vad familj och släkt brukar behöva eller vara intresserade av. Det är ett sätt att välja relevanta exempel, inte ett löfte om vad som säljer lättast. Berätta sakligt om produkterna.",
  ],
  [
    "En leverans som fungerar",
    "Kontrollera vilka leveransalternativ som erbjuds och förklara skillnaden för kunderna. Hemleverans och gemensam leverans innebär olika praktisk planering. Vid utdelning via klassen behöver en vuxen hålla ihop mottagande och utdelning.",
  ],
  [
    "Rimlig hantering för eleverna",
    "Prata om vem som delar länkar, svarar på praktiska frågor och hjälper till vid en eventuell utdelning. Med digital beställning behöver eleverna inte hantera kontanter. Vuxna ansvariga hjälper klassen att förstå upplägget och planera arbetet.",
  ],
];
export const SELLING_TIPS = [
  [
    "Dela med familj och släkt",
    "Använd den personliga säljlänken eller QR-koden och berätta hur kunden kan beställa. Dela med dem som vill stötta klassen och låt mottagaren själv avgöra om den vill handla.",
  ],
  [
    "Berätta om målet",
    "Säg vad pengarna ska användas till, till exempel en klassresa eller en gemensam aktivitet. Koppla försäljningen till det mål ni har kommit överens om, så att informationen blir tydlig för både elever och kunder.",
  ],
  [
    "Sätt delmål tillsammans",
    "Dela upp arbetet i steg som går att följa upp. Ett delmål kan handla om att alla får sina länkar eller om när ni ska stämma av läget. Undvik att behandla planeringen som en garanterad intäkt.",
  ],
  [
    "Påminn mitt i perioden",
    "Planera en vänlig påminnelse till dem som har visat intresse. Berätta hur länge försäljningen pågår och var sortimentet finns. Håll budskapet enkelt och tacka dem som hjälper till att sprida länken.",
  ],
  [
    "Välj leverans som passar",
    "Produkterna kan levereras hem till kunden eller gemensamt till klassen när det alternativet erbjuds. Förklara det valda upplägget innan ni delar länkarna. Vid gruppleverans ansvarar den klassansvariga för utdelningen.",
  ],
];
export const SELLING_FAQ = [
  {
    q: "Vad är lättast att sälja med klassen?",
    a: "Det beror på vilka ni når och vad köparna behöver. Börja med produkter ni kan beskriva tydligt och jämför pris, förtjänst och leverans. Det finns ingen produkt som passar alla kunder. Exemplen i guiden hjälper er att se olika kategorier utan att lova att en viss produkt säljer bäst.",
  },
  {
    q: "Hur mycket tjänar klassen per produkt?",
    a: "Med SalesPartner är provisionen bunden till produkt och variant. Korten visar exempel ur sortimentet och klassens provision i hela kronor, avrundad nedåt. Det är villkoren för den produkt eller variant som faktiskt köps som gäller. Planeringsvärdet 74 kr är inte en garanterad förtjänst per produkt.",
  },
  {
    q: "Måste eleverna hantera pengar eller varor?",
    a: "Med SalesPartner beställer och betalar kunden online, så eleverna behöver inte hantera kontanter. Leverans kan ske hem till kunden eller gemensamt till klassen när det erbjuds. Vid gruppleverans tar den klassansvariga emot beställningarna och ansvarar för utdelningen. Hur mycket praktiskt arbete som behövs beror därför på leveransvalet.",
  },
  {
    q: "Hur lång tid ska försäljningen pågå?",
    a: "Klassen planerar sin säljperiod utifrån det gemensamma målet och den tid ni har. Lägg också in tid för förberedelser, leverans och redovisning. Med SalesPartner kan utbetalning begäras när alla beställningar har levererats och 14 dagar passerat. Returer och återbetalningar kan påverka slutbeloppet.",
  },
  {
    q: "Kan vi kombinera produktförsäljning med loppis eller kafé?",
    a: "Ja, ni kan planera flera sätt att samla till samma gemensamma mål. Fördela ansvar och tid så att arbetet är begripligt för elever och föräldrar. Kontrollera med skolan när en aktivitet berör skolans lokaler eller verksamhet, och håll ordning på kostnader och intäkter för varje del.",
  },
];
